import { useEffect, useState } from 'react';
import socket_sv from 'src/utils/service/SocketSv';
const useNetworkRTT = () => {
    const [rtt, setRtt] = useState(1);

    useEffect(() => {
        const measureRTT = async () => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
                controller.abort(); // Hủy request nếu quá 3 giây
            }, 3000);
            const start = performance.now();
            try {
                // Tải tệp nhỏ (ví dụ favicon, ảnh nhỏ, hoặc một endpoint nhẹ)
                await fetch(socket_sv.server_domain + '/favicon.ico', {
                    signal: controller.signal,
                    method: 'HEAD',
                    cache: 'no-store',
                })
                    .then((res) => {
                        if (!res.ok) throw new Error('Bad response');
                        const end = performance.now();
                        setRtt(Math.round(end - start)); // RTT (ms)
                    })
                    .catch((err) => {
                        console.log('connection client error: ' + err);
                        setRtt(999);
                    })
                    .finally(() => {
                        clearTimeout(timeoutId);
                    });
            } catch (error) {
                setRtt(999); // lỗi, không đo được
            }
        };

        // Đo lần đầu
        measureRTT();
        // Đo mỗi 1 giây
        const interval = setInterval(measureRTT, 1500);

        return () => clearInterval(interval);
    }, []);
    return rtt;
};

export default useNetworkRTT;
